import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Loader } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { usePractisingSensibleEconomics } from "../../Sustainability.hook";
import { fields, fieldsReady } from "./constants";
export const MainContent: React.FC = (): JSX.Element => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");
  const [fieldData, setFieldData] = useState<any>();
  const [payloadData, setPayloadData] = useState<any>();

  const {
    data: profileData,
    isLoading: isLoadingProfile,
    refetch: refetchOurProfile,
  } = usePractisingSensibleEconomics();
  const {
    data: profileDataById,
    isLoading: isLoadingprofileById,
    refetch: refetchOurProfileById,
  } = useDocumentDetails(query?.get("id") || "");

  console.log("profileDataById", profileDataById, profileData, payloadData);

  useEffect(() => {
    if (query?.get("id")) {
      setPayloadData(profileDataById?.payload);
    } else {
      setPayloadData(profileData?.[0]);
    }
  }, [profileData, profileDataById]);

  useEffect(() => {
    if (approveId) {
      refetchOurProfileById();
    } else {
      refetchOurProfile();
    }
  }, [query.get("subActiveTab"), approveId]);

  async function fetchData() {
    await fieldsReady;

    setFieldData(fields);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const NextPageFormConfig: FormConfig = {
    initialValues: {
      [`field_content_english.data.nextPage.name`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_english)?.data?.nextPage?.name)
        : decodeHTML(profileData?.[0]?.field_content_english?.data?.nextPage?.name),

      [`field_content_english.data.nextPage.link`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_english)?.data?.nextPage?.link)
        : decodeHTML(profileData?.[0]?.field_content_english?.data?.nextPage?.link),
      [`field_content_malay.data.nextPage.name`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_malay)?.data?.nextPage?.name)
        : decodeHTML(profileData?.[0]?.field_content_malay?.data?.nextPage?.name),
      [`field_content_malay.data.nextPage.link`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_malay)?.data?.nextPage?.link)
        : decodeHTML(profileData?.[0]?.field_content_malay?.data?.nextPage?.link),
      [`field_content_mandarin.data.nextPage.name`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_mandarin)?.data?.nextPage?.name)
        : decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.nextPage?.name),
      [`field_content_mandarin.data.nextPage.link`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_mandarin)?.data?.nextPage?.link)
        : decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.nextPage?.link),
    },
    fields: fields?.nextPageOurPolicies,
  };

  console.log("NextPageFormConfig", NextPageFormConfig.fields, NextPageFormConfig.initialValues);

  const MainContentFormConfig: FormConfig = {
    initialValues: {
      [`field_content_english.data.banner`]: profileDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: JSON.parse(profileDataById?.payload?.field_content_english)?.data?.banner,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: profileData?.[0]?.field_content_english?.data?.banner,
            },
          ]),

      [`field_content_english.data.title`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_english)?.data?.title)
        : decodeHTML(profileData?.[0]?.field_content_english?.data?.title),
      [`field_content_english.data.introText`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_english)?.data?.introText)
        : decodeHTML(profileData?.[0]?.field_content_english?.data?.introText),
      [`field_content_english.data.extroText`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_english)?.data?.extroText)
        : decodeHTML(profileData?.[0]?.field_content_english?.data?.extroText),
      [`field_content_malay.data.banner`]: profileDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: JSON.parse(profileDataById?.payload?.field_content_malay)?.data?.banner,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: profileData?.[0]?.field_content_malay?.data?.banner,
            },
          ]),

      [`field_content_malay.data.title`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_malay)?.data?.title)
        : decodeHTML(profileData?.[0]?.field_content_malay?.data?.title),
      [`field_content_malay.data.introText`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_malay)?.data?.introText)
        : decodeHTML(profileData?.[0]?.field_content_malay?.data?.introText),
      [`field_content_malay.data.extroText`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_malay)?.data?.extroText)
        : decodeHTML(profileData?.[0]?.field_content_malay?.data?.extroText),
      [`field_content_mandarin.data.banner`]: profileDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: JSON.parse(profileDataById?.payload?.field_content_mandarin)?.data?.banner,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: profileData?.[0]?.field_content_mandarin?.data?.banner,
            },
          ]),

      [`field_content_mandarin.data.title`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_mandarin)?.data?.title)
        : decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.title),
      [`field_content_mandarin.data.introText`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_mandarin)?.data?.introText)
        : decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.introText),
      [`field_content_mandarin.data.extroText`]: profileDataById?.payload
        ? decodeHTML(JSON.parse(profileDataById?.payload?.field_content_mandarin)?.data?.extroText)
        : decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.extroText),
    },
    fields: fields?.practisingSensibleEconomicsMainContent,
  };

  const updatePayload = (data: any) => {
    console.log("updatePayloadData", data, payloadData);
    const convertDotNotation = (obj: any): any => {
      const result: any = {};
      for (const key in obj) {
        if (key.includes(".")) {
          const topLevelKey = key.split(".")[0];
          if (obj[topLevelKey] && typeof obj[topLevelKey] === "object") {
            continue;
          }

          const parts = key.split(".");
          let current = result;

          for (let i = 0; i < parts.length - 1; i++) {
            current[parts[i]] = current[parts[i]] || {};
            current = current[parts[i]];
          }

          current[parts[parts.length - 1]] = obj[key];
        } else {
          result[key] = obj[key];
        }
      }

      return result;
    };

    const filterNestedObjects = (obj: any): any => {
      const result: any = {};

      for (const key in obj) {
        if (typeof obj[key] === "object" && obj[key] !== null) {
          if (Array.isArray(obj[key])) {
            result[key] = obj[key];
          } else {
            result[key] = filterNestedObjects(obj[key]);
          }
        } else {
          result[key] = obj[key];
        }
      }

      return result;
    };

    const replacePayload = (target: any, source: any) => {
      console.log("replacePayload", target, source);

      for (const key in source) {
        console.log("sourceKey", key, target[key], source[key], Array.isArray(source[key]));

        if (key === "banner") {
          const imageData = source[key];

          if (Array.isArray(imageData)) {
            if (imageData[0]?.originFileObj) {
              target[key] = imageData;
            } else {
              target[key] = imageData[0]?.url ?? undefined;
            }
          } else if (typeof imageData === "object" && imageData !== null) {
            // Ensure `undefined` values are explicitly handled
            target[key] = imageData.url !== undefined ? imageData.url : undefined;
          } else {
            target[key] = undefined;
          }
        } else if (typeof source[key] === "object" && source[key] !== null && !(source[key] instanceof Array)) {
          // If target[key] does not exist, initialize it as an object
          if (!target[key] || typeof target[key] !== "object") {
            target[key] = {};
          }
          replacePayload(target[key], source[key]);
        } else {
          // Assign values, making sure undefined values do not override existing values
          target[key] = source[key] !== undefined ? source[key] : target[key];
        }
      }
    };

    const convertedData = convertDotNotation(data);
    const filteredData = filterNestedObjects(convertedData);
    console.log("Data for...", data, filteredData, convertedData);
    const payloads = payloadData;
    // const payload = { ...payloadData[0] };
    replacePayload(payloads, filteredData);
    return payloads;
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    const updateNestedProperty = (obj: any, path: string, value: any) => {
      const keys = path.split(".");
      let current = obj;

      for (let i = 0; i < keys.length - 1; i++) {
        if (!current[keys[i]]) current[keys[i]] = {};
        current = current[keys[i]];
      }

      current[keys[keys.length - 1]] = value;
    };

    const getNestedValue = (obj: any, path: string) => {
      return path.split(".").reduce((o: any, i: string) => {
        if (o == null) return undefined;
        return o[i];
      }, obj);
    };

    const payloadDatas = await updatePayload(data);

    let imageKeys = [
      "field_content_english.data.banner",
      "field_content_malay.data.banner",
      "field_content_mandarin.data.banner",
    ];

    for (const key of imageKeys) {
      try {
        let field = key.split(".").reduce((o, i) => (o ? o[i] : undefined), payloadDatas);

        if (field && field[0]) {
          if (field[0].originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", field[0].originFileObj);
            formData.append("application", "CORPORATE");
            const res: any = await post("management/upload-file", formData);

            if (res) {
              updateNestedProperty(payloadDatas, key, res.response.data);
            }
          } else if (field[0].url) {
            updateNestedProperty(payloadDatas, key, field[0].url);
          }
        }
      } catch (error) {
        console.error("Error updating image field:", key, error);
      }
    }

    const englishBannerKey = "field_content_english.data.banner";
    const englishBanner = getNestedValue(payloadDatas, englishBannerKey);
    if (englishBanner) {
      updateNestedProperty(payloadDatas, "field_content_malay.data.banner", englishBanner);
      updateNestedProperty(payloadDatas, "field_content_mandarin.data.banner", englishBanner);
    }
    if (payloadDatas.field_content_english) {
      payloadDatas.field_content_english = JSON.stringify(payloadDatas.field_content_english);
    }
    if (payloadDatas.field_content_malay) {
      payloadDatas.field_content_malay = JSON.stringify(payloadDatas.field_content_malay);
    }
    if (payloadDatas.field_content_mandarin) {
      payloadDatas.field_content_mandarin = JSON.stringify(payloadDatas.field_content_mandarin);
    }
    let payload = {
      action: action,
      method: method,
      module: "Sustainability",
      subModule: `${query?.get("activeTab")}_${query?.get("subActiveTab")}`,
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Sustainability_Practising Sensible Economics",
      payload: payloadDatas,
      status: status,
    };

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  if (isLoadingprofileById || isLoadingProfile) {
    return <Loader />;
  }

  return (
    <>
      <DynamicForm
        isLoading={isLoadingProfile || isLoadingprofileById}
        config={MainContentFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${corporateHost}/api/page-content/${profileData?.[0]?.id || profileDataById?.payload?.id || "88"}`,
            "UPDATE",
            "PATCH",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Sustainability"
      />
    </>
  );
};
